import 'css-chunksrc/client/app/router/loader/styles.scss';export default {
  "loader": "_loader_hyif4_1",
  "logo": "_logo_hyif4_9",
  "icon": "_icon_hyif4_21"
};